import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './SubscriptionStyles.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://worthy-optimism-production.up.railway.app/api';

const PaymentOptions = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { user } = useAuth(); // Get user info if available

    // Use effect to clear errors if the component re-renders
    useEffect(() => {
        setError('');
    }, []);

    // Form submission to Monri
    const submitMonriForm = (monriFormUrl, formData) => {
        setLoading(true);
        
        // Create a hidden form
        const form = document.createElement('form');
        form.id = 'monri-redirect-form';
        form.method = 'POST';
        form.action = monriFormUrl;
        form.target = '_self';
        form.style.display = 'none'; // Hide the form
        
        // Add all form data as hidden inputs
        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = formData[key];
                form.appendChild(input);
            }
        }
        
        // Log form details for debugging
        console.log("Form URL:", monriFormUrl);
        console.log("Form Data:", formData);
        
        // Add form to the document and submit
        document.body.appendChild(form);
        
        try {
            console.log("Submitting payment form...");
            form.submit();
        } catch (error) {
            console.error("Error submitting form:", error);
            setLoading(false);
            setError("Error redirecting to payment processor. Please try again.");
        }
    };

    const handlePayWithCard = async () => {
        setLoading(true);
        setError('');

        try {
            // Determine amount
            const amount = 59; // Standard plan price
            const currency = 'EUR';
            
            // Get user details if available
            const email = user?.email || localStorage.getItem('userEmail') || '';
            const fullName = user?.fullName || localStorage.getItem('userName') || '';
            
            console.log("Initiating Monri payment with details:", { amount, currency, email, fullName });
            
            // Use the payment initiation endpoint
            const response = await axios.post(`${API_URL}/payments/initiate-monri`, {
                amount,
                currency,
                email,
                fullName
            });

            if (response.data && response.data.monriFormUrl && response.data.formData) {
                console.log("Received Monri form data, redirecting to payment...");
                
                // Save user email in localStorage for after redirect
                if (email && !localStorage.getItem('userEmail')) {
                    localStorage.setItem('userEmail', email);
                }
                if (fullName && !localStorage.getItem('userName')) {
                    localStorage.setItem('userName', fullName);
                }
                
                // Submit form to Monri
                submitMonriForm(response.data.monriFormUrl, response.data.formData);
            } else {
                console.error("Invalid response from backend:", response.data);
                setError('Failed to get payment details from server.');
                setLoading(false);
            }

        } catch (err) {
            console.error('Error initiating payment:', err);
            let errorMessage = 'An error occurred while initiating payment. Please try again.';
            if (err.response) {
                console.error("Backend error data:", err.response.data);
                console.error("Backend error status:", err.response.status);
                errorMessage = err.response.data?.msg || `Server error: ${err.response.status}`;
            } else if (err.request) {
                console.error("No response received:", err.request);
                errorMessage = 'Could not connect to the server. Please check your internet connection.';
            } else {
                console.error('Axios error:', err.message);
                errorMessage = `Error: ${err.message}`;
            }
            setError(errorMessage);
            setLoading(false);
        }
    };

    const handlePayViaBank = () => {
        // Redirect to the bank instructions page
        navigate('/app/bank-instructions');
    };

    return (
        <div className="payment-options-container">
            <h2>Odaberite način plaćanja</h2>
            {error && <p className="error-message">{error}</p>}
            
            <div className="payment-option">
                <h3>Plaćanje karticom (Monri)</h3>
                <p>Sigurno plaćanje putem Monri payment gateway-a.</p>
                <button onClick={handlePayWithCard} disabled={loading} className="payment-button monri-button">
                    {loading ? 'Priprema...' : 'Plati karticom'}
                </button>
            </div>

            <div className="payment-option">
                <h3>Plaćanje putem banke (uplatnica)</h3>
                <p>Odaberite ovu opciju ako želite platiti putem internet bankarstva ili općom uplatnicom.</p>
                <p>Nakon odabira, prikazat će vam se podaci za uplatu. Vaša pretplata će biti aktivirana ručno nakon što evidentiramo uplatu.</p>
                <button onClick={handlePayViaBank} disabled={loading} className="payment-button bank-button">
                    Plati putem banke
                </button>
            </div>
        </div>
    );
};

export default PaymentOptions;